<template>
  <div class="auth-layout h-dvh w-full overflow-y-auto">
    <div class="flex min-h-full items-center justify-center px-4 py-6">
      <slot />
    </div>
  </div>
</template>

<style scoped>
/* The dark tint is layered into the background rather than an absolute overlay,
   so it covers the whole scrollable area when the form is taller than the viewport. */
.auth-layout {
  background-image: linear-gradient(rgb(0 0 0 / 0.2), rgb(0 0 0 / 0.2)), url('/images/background-desk.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
